// Rueckkehrziel des Vollbild-Consents (Popup blockiert), Spec 4.3 Punkt 0.
//
// AUSDRUECKLICH NICHT ueber den OAuth-`state`: google-oauth-handler/index.ts
// reicht `userId: state` nach dem Abschneiden von "ads:" unveraendert an
// handleAdsConnect; ein drittes Segment kaeme als Teil der UUID an und der
// Handler faende kein Konto. sessionStorage wie lib/entryMarker.ts: der Marker
// beschreibt EINE Landung. Jeder Zugriff in try/catch (gesperrter Site-Speicher
// darf den Connect nicht kippen). Fehlt der Marker, bleibt das heutige Ziel
// /internal/ads-performance (Connect aus dem internen Panel).
export const ADS_CONNECT_RETURN_KEY = 'fo:ads-connect-return';
export type AdsConnectReturn = 'feed_check' | 'settings';

export function writeAdsConnectReturn(target: AdsConnectReturn): void {
  try { sessionStorage.setItem(ADS_CONNECT_RETURN_KEY, target); } catch { /* ohne Speicher gilt das alte Ziel */ }
}

export function takeAdsConnectReturn(): AdsConnectReturn | null {
  try {
    const raw = sessionStorage.getItem(ADS_CONNECT_RETURN_KEY);
    sessionStorage.removeItem(ADS_CONNECT_RETURN_KEY);
    return raw === 'feed_check' || raw === 'settings' ? raw : null;
  } catch {
    return null;
  }
}

export function adsConnectReturnPath(target: AdsConnectReturn, outcome: 'success' | 'error', code?: string): string {
  const base = target === 'settings' ? '/settings?tab=accounts&' : '/?';
  const tail = outcome === 'success' ? 'adsOauth=success' : `adsOauth=error&code=${encodeURIComponent(code ?? 'ADS_CONNECT_FAILED')}`;
  return `${base}${tail}`;
}
